import { lazy, Suspense, useMemo, useState } from "react";
import { Outlet } from "react-router";
import MainContextProvider from "../context/MainContextProvider";
import Footer from "./Footer.tsx";
import Header from "./header/Header.tsx";
import MobileHeader from "./header/mobileHeader/MobileHeader.tsx";
import useScreenSize from "../hooks/useScreenSize.ts";
import { MOBILE_BREAKPOINT } from "../constants.ts";
import FrameworkSnackbar from "./FrameworkSnackbar.tsx";
import HeaderEvents from "./header/HeaderEvents.tsx";
import TransparentLoader from "../views/common/loader/TransparentLoader.tsx";
import ShadowComponent from "./ShadowComponent.tsx";
import AgentChat from "@/layout/agentChat/AgentChatDrawer.tsx";

const DocumentationView = lazy(() => import("../views/Documentation/DocsViewUI.tsx"));

const MainLayout = () => {
  const { width } = useScreenSize();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const contextValue = useMemo(
    () => ({
      isLoading,
      setIsLoading,
    }),
    [isLoading, setIsLoading],
  );

  return (
    <MainContextProvider.Provider value={contextValue}>
      <div id="main-layout" data-testid="main-layout">
        <HeaderEvents />
        <ShadowComponent>
          {width > MOBILE_BREAKPOINT ? <Header /> : <MobileHeader />}
          <AgentChat />
        </ShadowComponent>
        <div className="framework-main-content-wrapper">
          <div className="framework-main-content">
            <div data-testid="loader-container">
              <TransparentLoader isLoading={isLoading} />
            </div>
            <Suspense fallback={<TransparentLoader isLoading={true} />}>
              <Outlet />
            </Suspense>
          </div>
            <DocumentationView />
        </div>
        <Footer />
        <FrameworkSnackbar />
      </div>
    </MainContextProvider.Provider>
  );
};

export default MainLayout;
